import React, { FC, ReactNode, useState } from 'react';
import { InventoryStoreContext } from './context';
import { AddStoreItemType } from 'models/store-item.model';

import { StoreItemType } from 'models/store-item.model';
import { ActiveType } from 'models/vendors.model';
import { ENUM_UNIT } from 'models/common.model';

export const DefaultStoreItem: AddStoreItemType = {
  name: '',
  quantity: '',
  unit: 0,
  category: '',
  vendors: [],
  min_quantity_unit: ENUM_UNIT.GRAM,
  shelfLife: 0
};

const InventoryStoreProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [storeItemsToEdit, setStoreItemsToEdit] = useState<StoreItemType[]>([]);
  const [storeItemArray, setStoreItemArray] = useState<AddStoreItemType[]>([DefaultStoreItem]);
  const [active, setActive] = useState<ActiveType | null>('manual');
  const [step, setStep] = useState(1);

  return (
    <InventoryStoreContext.Provider
      value={{
        storeItemArray,
        setStoreItemArray,
        storeItemsToEdit,
        setStoreItemsToEdit,
        active,
        setActive,
        step,
        setStep
      }}>
      {children}
    </InventoryStoreContext.Provider>
  );
};

export default InventoryStoreProvider;
